import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DISCORD_URL, EMAIL_SUPPORT } from '@app/config';
import { FaqAccordionComponent, SectionHeaderComponent } from '@app/widgets';
import { COMPARE_IONIC_APPFLOW_FAQS } from '../../constants';

@Component({
  selector: 'app-compare-ionic-appflow-faq-section',
  imports: [SectionHeaderComponent, FaqAccordionComponent],
  templateUrl: './compare-ionic-appflow-faq-section.component.html',
  styleUrl: './compare-ionic-appflow-faq-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompareIonicAppflowFaqSectionComponent {
  protected readonly discordUrl = DISCORD_URL;
  protected readonly emailSupport = EMAIL_SUPPORT;
  protected readonly items = COMPARE_IONIC_APPFLOW_FAQS;
}
